import { tw } from "@/utils";
import { ClassNameValue } from "tailwind-merge";
import CareSync from "@/assets/CareSync.svg?react";
import EyeInvisible from "./assets/eyeInvisible.svg?react";
import EyeVisible from "./assets/eyeVisible.svg?react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginDTO, loginSchema } from "./types";
import { useNavigate } from "react-router";
import { useLogin } from "@/api/login";

export const Login = () => {
  const navigate = useNavigate();

  const { mutate } = useLogin();

  const [isPasswordHide, setIsPasswordHide] = useState<boolean>(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginDTO>({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = handleSubmit(
    (data) => {
      mutate(data, {
        onSuccess(data) {
          console.log(data);
          navigate("/");
        },
      });
    },
    (error) => {
      console.log(error);
    }
  );

  return (
    <div
      className={tw(
        "flex w-full h-full  text-xl font-medium p-[20px]",
        "bg-gradient-to-r from-purple-100 to-[#201b94]"
      )}
    >
      <div
        className={tw(
          "w-[550px] h-[520px] rounded-[20px] bg-white shadow-login-box",
          "flex flex-col items-center justify-between",
          "m-auto px-[60px] pt-[90px] pb-[70px]"
        )}
        onKeyDown={(key) => {
          if (key.code === "Enter") {
            onSubmit();
          }
        }}
      >
        <div className="flex gap-[6px] items-center">
          <CareSync className="w-[54px] h-[47px]" />
          <div className="text-[#3B35C0] font-bold text-[30px]">CareSync</div>
        </div>
        <div className="w-full flex flex-col gap-[40px]">
          <div className="relative w-full h-[48px]">
            <input
              className={tw(inputStyle(!!errors.email))}
              placeholder="이메일을 입력해주세요."
              type="email"
              {...register("email")}
            />
          </div>
          <div className="relative w-full h-[48px]">
            <input
              className={tw(inputStyle(!!errors.password), "pr-[38px]")}
              placeholder="비밀번호를 입력해주세요."
              type={isPasswordHide ? "password" : "text"}
              {...register("password")}
            />
            <button
              className="absolute top-[12px] right-[14px] w-[24px] h-[24px]"
              onClick={() => setIsPasswordHide((prev) => !prev)}
            >
              {isPasswordHide ? (
                <EyeInvisible className="w-full h-full" />
              ) : (
                <EyeVisible className="w-full h-full" />
              )}
            </button>
          </div>
        </div>
        <button
          className="w-full h-[48px] bg-purple-100 text-white rounded-[12px] font-semibold text-base"
          onClick={onSubmit}
        >
          로그인
        </button>
      </div>
    </div>
  );
};

const inputStyle: (isError: boolean) => ClassNameValue = (isError) =>
  tw(
    "relative w-full h-full px-[14px] py-[12px]",
    "border-[1px] border-solid border-gray-g75 rounded-[12px]",
    "text-gray-100 font-regular text-base leading-[22px]",
    isError && "border-red outline-red"
  );
